// Pre-order Summary
export const PRE_ORDER_EVENT_OVERVIEW_REQUEST = 'PRE_ORDER_EVENT_OVERVIEW_REQUEST';
export const PRE_ORDER_EVENT_OVERVIEW_SUCCESS = 'PRE_ORDER_EVENT_OVERVIEW_SUCCESS';
export const PRE_ORDER_EVENT_OVERVIEW_FAILURE = 'PRE_ORDER_EVENT_OVERVIEW_FAILURE';

export const PRE_ORDER_BY_ORDER_DATE_REQUEST = 'PRE_ORDER_BY_ORDER_DATE_REQUEST';
export const PRE_ORDER_BY_ORDER_DATE_SUCCESS = 'PRE_ORDER_BY_ORDER_DATE_SUCCESS';
export const PRE_ORDER_BY_ORDER_DATE_FAILURE = 'PRE_ORDER_BY_ORDER_DATE_FAILURE';

export const PRE_ORDER_BY_PICKUP_SLOT_REQUEST = 'PRE_ORDER_BY_PICKUP_SLOT_REQUEST';
export const PRE_ORDER_BY_PICKUP_SLOT_SUCCESS = 'PRE_ORDER_BY_PICKUP_SLOT_SUCCESS';
export const PRE_ORDER_BY_PICKUP_SLOT_FAILURE = 'PRE_ORDER_BY_PICKUP_SLOT_FAILURE';

export const PRE_ORDERS_BY_CHANNELS_REQUEST = 'PRE_ORDERS_BY_CHANNELS_REQUEST';
export const PRE_ORDERS_BY_CHANNELS_SUCCESS = 'PRE_ORDERS_BY_CHANNELS_SUCCESS';
export const PRE_ORDERS_BY_CHANNELS_FAILURE = 'PRE_ORDERS_BY_CHANNELS_FAILURE';

// Pre-order Details :
export const PRE_ORDER_DETAILS_REQUEST = 'PRE_ORDER_DETAILS_REQUEST';
export const PRE_ORDER_DETAILS_SUCCESS = 'PRE_ORDER_DETAILS_SUCCESS';
export const PRE_ORDER_DETAILS_FAILURE = 'PRE_ORDER_DETAILS_FAILURE';

// Event Name Filter Values :
export const EVENT_NAME_FILTER_VALUES_REQUEST = "EVENT_NAME_FILTER_VALUES_REQUEST";
export const EVENT_NAME_FILTER_VALUES_SUCCESS = "EVENT_NAME_FILTER_VALUES_SUCCESS";
export const EVENT_NAME_FILTER_VALUES_FAILURE = "EVENT_NAME_FILTER_VALUES_FAILURE";

// Event name global :
export const EVENT_NAME_GOLBAL = "EVENT_NAME_GOLBAL"

export const EVENT_START_DATE= "EVENT_START_DATE"
export const EVENT_END_DATE= "EVENT_END_DATE"
export const EVENT_SELECTED_DATE_FILTER_TYPE = "EVENT_SELECTED_DATE_FILTER_TYPE"

export const EVENT_PRE_ORDER_BY_PICKUP_SLOT_DATE_REQUEST = "EVENT_PRE_ORDER_BY_PICKUP_SLOT_DATE_REQUEST";

// Event Slots Filter :
export const EVENT_SLOTS_FILTER_REQUEST = "EVENT_SLOTS_FILTER_REQUEST"
export const EVENT_SLOTS_FILTER_SUCCESS = "EVENT_SLOTS_FILTER_SUCCESS"
export const EVENT_SLOTS_FILTER_FAILURE = "EVENT_SLOTS_FILTER_FAILURE"


// Event Selected Time Slot :
export const EVENT_SELECTED_TIME_SLOT = "EVENT_SELECTED_TIME_SLOT";

// Pre-Order Summary Global Date Filter :
export const PRE_ORDER_SUMMARY_GLOBAL_START_DATE = "PRE_ORDER_SUMMARY_GLOBAL_START_DATE";
export const PRE_ORDER_SUMMARY_GLOBAL_END_DATE = "PRE_ORDER_SUMMARY_GLOBAL_END_DATE";
export const PRE_ORDER_SUMMARY_GLOBAL_SELECTED_DATE_FILTER_TYPE = "PRE_ORDER_SUMMARY_GLOBAL_SELECTED_DATE_FILTER_TYPE"